
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CoreAdvantagesSection from './components/CoreAdvantagesSection';
import CareerConfusionSection from './components/CareerConfusionSection';
import ResumeThresholdSection from './components/ResumeThresholdSection';
import SkillImprovementSection from './components/SkillImprovementSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import MediaSection from './components/MediaSection';
import AssessmentSection from './components/AssessmentSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <CoreAdvantagesSection />
        <CareerConfusionSection />
        <ResumeThresholdSection />
        <SkillImprovementSection />
        <CaseStudiesSection />
        <MediaSection />
        <AssessmentSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
